import { userActions } from './user-actions';

export default {
  '/users': userActions.MENU_USER,
  '/roleList': userActions.MENU_ROLE,
  '/decision': userActions.MENU_DECISION,
  '/decisionTypeList': userActions.MENU_DECISION_TYPE,
  '/signet': userActions.MENU_SIGNET,
  '/requestForSignetApproval': userActions.MENU_REQUEST_FOR_SIGNET_APPROVAL,
  '/requestForSignetApprovalProcessingView':
    userActions.REQUEST_FOR_SIGNET_APPROVAL_PROCESSING_VIEW,
  '/signetProcessingView': userActions.SIGNET_PROCESSING_VIEW,
  '/usersOfPublicFunds': userActions.MENU_KJS,
  '/signetExampleList': userActions.MENU_SIGNET_EXAMPLES,
  '/place': userActions.MENU_PLACE,
  '/municipality': userActions.MENU_MUNICIPALITY,
};
